var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.4535,
    cy: 22.4535,
    r: 22.4535,
    fill: "#F5F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.861 12.7525H31.5457V15.4373H28.861V12.7525Z",
    fill: "#FFCA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.861 16.7796H31.5457V19.4644H28.861V16.7796Z",
    fill: "#FFCA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8339 12.7525H27.5186V15.4373H24.8339V12.7525Z",
    fill: "#FFCA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8339 16.7796H27.5186V19.4644H24.8339V16.7796Z",
    fill: "#FFCA00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2034 22.1491V26.1762H14.0949V15.4373H22.1492V14.0949H14.0949C13.7389 14.0949 13.3975 14.2363 13.1457 14.4881C12.894 14.7398 12.7526 15.0813 12.7526 15.4373V26.1762C12.7526 26.5323 12.894 26.8737 13.1457 27.1254C13.3975 27.3772 13.7389 27.5186 14.0949 27.5186H19.4644V30.2034H16.7797V31.5457H27.5186V30.2034H24.8339V27.5186H30.2034C30.5594 27.5186 30.9008 27.3772 31.1526 27.1254C31.4043 26.8737 31.5457 26.5323 31.5457 26.1762V22.1491H30.2034ZM23.4915 30.2034H20.8068V27.5186H23.4915V30.2034Z",
    fill: "#297AFB",
    stroke: "#2176FF",
    strokeWidth: 0.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebApp);
export default __webpack_public_path__ + "static/media/webApp.f3a1e103113eeeebe4da2320974386ba.svg";
export { ForwardRef as ReactComponent };